import ProcurementLocationType from './ProcurementLocationTypes';

/** Lane Search Actions start */
export const getProcurementLocationListInProgress = (payload) => {
  return {
    type: ProcurementLocationType.GET_PROCUREMENT_LOCATION_LIST,
    payload,
  };
};

export const getProcurementLocationListInSuccess = (payload) => {
  return {
    type: ProcurementLocationType.GET_PROCUREMENT_LOCATION_LIST_SUCCESS,
    payload,
  };
};

export const getProcurementLocationListInFail = (payload) => {
  return {
    type: ProcurementLocationType.GET_PROCUREMENT_LOCATION_LIST_FAIL,
    payload,
  };
};

export const setProcurementLocationListRequest = (payload) => {
  return {
    type: ProcurementLocationType.SET_PROCUREMENT_LOCATION_LIST_REQUEST,
    payload,
  };
};

export const resetProcurementLocationList = (payload) => {
  return {
    type: ProcurementLocationType.RESET_PROCUREMENT_LOCATION_LIST,
    payload,
  };
};
/** Lane Search Actions end */

export const setAddNewLocation = (payload) => {
  return { type: ProcurementLocationType.SET_ADD_NEW_LOCATION, payload };
};

export const createProcurementLocationInProgress = (payload) => {
  return {
    type: ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION,
    payload,
  };
};

export const createProcurementLocationInSuccess = (payload) => {
  return {
    type: ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION_SUCCESS,
    payload,
  };
};

export const createProcurementLocationInFail = (payload) => {
  return {
    type: ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION_FAIL,
    payload,
  };
};

export const clearProcurementLocationCreation = () => {
  return {
    type: ProcurementLocationType.CLEAR_PROCUREMENT_LOCATION_CREATION,
  };
};

export const createProcurementLocationRequestReset = () => {
  return {
    type: ProcurementLocationType.CREATE_UPDATE_PROCUREMENT_LOCATION_REQUEST_RESET,
  };
};

export const updateSelectedLocation = (payload) => {
  return { type: ProcurementLocationType.UPDATE_SELECTED_LOCATION, payload };
};

export const checkSelectionValueUpdate = (payload) => {
  return { type: ProcurementLocationType.CHECK_SELECTED_LOCATION_VALUE_UPDATE, payload };
};
